import * as actions from "Actions";
import * as api from "Api";
import { pushSourceToken, getMediaMimeTypeFromUrl } from "Utils";

export const fetchMails = ({ limit = 20, offset = 0, status, lrId = null }) => {
  return (dispatch, getState) => {
    let sourceToken = pushSourceToken("FETCH_MAILS", dispatch);

    const { token } = getState().auth;

    const help = api.getMails({
      token,
      limit,
      offset,
      lrId,
      sourceToken,
      status
    });

    return dispatch(
      lrId ? actions.fetchClientMails(help) : actions.fetchMails(help)
    );
  };
};

export const fetchInfiniteMails = ({ status, lrId = null }) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { offset, limit } = lrId
      ? getState().ebox.client
      : getState().ebox.mails;

    const help = api.getMails({
      token,
      limit,
      offset,
      lrId,
      status
    });
    return dispatch(
      lrId
        ? actions.fetchInfiniteClientMails(help)
        : actions.fetchInfiniteMails(help)
    );
  };
};

export const fetchMail = mailId => {
  return (dispatch, getState) => {
    const { token } = getState().auth;

    return dispatch(actions.fetchSingleMail(api.getSingleMail(token, mailId)));
  };
};

export const fetchGallery = ({ limit = 30, offset = 0 }) => {
  return (dispatch, getState) => {
    const { token } = getState().auth;
    const { lng } = getState().params;
    let medias = [];

    return dispatch(
      actions.fetchGallery(
        api.getGallery({ token, limit, offset }).then(resp => {
          dispatch(actions.resetMediasByType());

          const items = [...resp.data.data];
          for (let i = 0; i < items.length; i++) {
            const { urls, from, sentAt } = items[i];
            if (urls && urls.length > 0) {
              for (let j = 0; j < urls.length; j++) {
                getMediaMimeTypeFromUrl(urls[j].replace("/prod/", "/v2/")).then(
                  response => {
                    if (response) {
                      const { status, headers } = response;
                      if (status === 200) {
                        let type = "";
                        switch (headers["content-type"]) {
                          case "application/pdf":
                            type = "PDF";
                            break;
                          case "image/jpeg":
                          case "image/png":
                          case "image/gif":
                            type = "IMAGE";
                            break;
                          default:
                        }
                        let help = {
                          fullMediaUrl: urls[j].replace("/prod/", "/v2/"),
                          docType: type,
                          createdAt: sentAt.date
                        };
                        help[
                          `title${lng.charAt(0).toUpperCase() + lng.slice(1)}`
                        ] = from;
                        if (type !== "IMAGE") {
                          help.preview = {
                            fullMediaUrl: `${urls[j]}/w240.jpg`
                          };
                        }
                        medias.push(help);
                      }
                    }
                    dispatch(actions.setGalleryItems(medias));
                  }
                );
              }
            }
          }
          return medias;
        })
      )
    );
  };
};



// WEBPACK FOOTER //
// ./src/actions/thunks/ebox.js